import { Seo } from "@/components/site/Seo";
import { SiteLayout } from "@/components/site/SiteLayout";
import { OrderForm } from "@/components/site/OrderForm";
import { SocialMarquee } from "@/components/site/SocialMarquee";
import { Logo } from "@/components/site/Logo";

export default function Order() {
  return (
    <SiteLayout>
      <Seo title="Sipariş Ver - TakipciSatis.com" description="Sosyal medya hizmeti siparişi verin. Instagram, TikTok, YouTube ve daha fazlası." canonical="https://takipcisatis.com/siparis-ver" />
      <section className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4"><Logo className="h-12" /></div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white">Sipariş Ver</h1>
          <p className="text-gray-400 mt-2">Platform ve servisi seçin, saniyeler içinde sipariş verin.</p>
        </div>
        <OrderForm />
      </section>
      <SocialMarquee />
    </SiteLayout>
  );
}
